import { SubmitNewQuote } from "@/components/SubmitNewQuote";

export function QuoteNotFoundPage() {
  return (
    <div className="max-w-[1500px] mx-auto h-full min-h-screen flex px-4 xl:px-16 py-[10dvh] flex-col items-center">
      <div className="flex flex-col justify-center gap-[10dvh]">
        <div className="w-full h-full flex flex-col gap-16 xl:flex-row xl:justify-between items-center">
          <div className="flex flex-col gap-12 w-full xl:w-[50%]">
            <div className="relative h-16 w-16 rounded-full flex justify-center items-center">
              <div className="bg-red-500 h-full w-full animate-pulse-scale rounded-full absolute inset-0" />
              <div className="bg-red-500 h-full w-full p-4 rounded-full absolute inset-0 z-10 flex items-center justify-center">
                <span className="text-white text-2xl font-bold">!</span>
              </div>
            </div>
            <h2 className="text-6xl font-semibold">Your quote wasn't found</h2>
            <p>
              We couldn't locate the quote you're looking for. It may have been
              removed, expired, or the link might be incorrect.
            </p>
            <p>
              If you have any questions or need further assistance, please
              contact
            </p>
            <a
              href="mailto:noa@themilesmarket.com"
              className="bg-[#ECFAFF] w-fit px-6 py-2 rounded-lg flex gap-2 hover:underline"
            >
              <img src="/checkout-success/send.svg" alt="send icon" />{" "}
              noa@themilesmarket.com
            </a>
          </div>
          <img
            src="/checkout-success/banner.svg"
            className="h-full max-h-[85dvh]"
            alt="submission not found banner"
          />
        </div>

        <SubmitNewQuote />
      </div>
    </div>
  );
}
